module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundBigBlackH.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundBigBlackH.png
// module id = 250
// module chunks = 0